// components/Hero.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  const [activeNodes, setActiveNodes] = useState(new Set());

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveNodes(prev => {
        const newSet = new Set(prev);
        // Remove some nodes
        if (newSet.size > 3) {
          const toRemove = Array.from(newSet).slice(0, 2);
          toRemove.forEach(node => newSet.delete(node));
        }
        // Add new nodes
        for (let i = 0; i < 3; i++) {
          newSet.add(Math.floor(Math.random() * 20));
        }
        return newSet;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          {/* <div className="hero-badge">
            <span className="badge-text">Enterprise-Grade Data Infrastructure</span>
          </div> */}

          <h1 className="hero-title">
            <span className="title-line">Our <span className='accent'>Datasets</span> drive</span>
            <span className="title-line">your <span className='accent'>Intelligence</span></span>
          </h1>

          <p className="hero-subtitle">
            {/* We architect datasets that power tomorrow's intelligence. */}
            From sophisticated web crawling to synthetic generation,
            we deliver the foundation for breakthrough AI models.
          </p>

          {/* <div className="hero-features">
            <div className="feature">
              <div className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span>Structured Data Mining</span>
            </div>
            <div className="feature">
              <div className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M21 16V8C20.9996 7.64927 20.9071 7.30481 20.7315 7.00116C20.556 6.69751 20.3037 6.44536 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44536 3.44398 6.69751 3.26846 7.00116C3.09294 7.30481 3.00036 7.64927 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 12V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span>Data Generation</span>
            </div>
            <div className="feature">
              <div className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span>Continuous Updates</span>
            </div>
          </div> */}

          <div className="hero-cta">
            <Link to='/datasets'>
            <button className="btn btn-primary">
              <span>Explore Datasets</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            </Link>
            {/* <button className="btn btn-secondary">Technical Documentation</button> */}
          </div>

          {/* <div className="hero-metrics">
            <div className="metric">
              <span className="metric-value">10B+</span>
              <span className="metric-label">Data Points</span>
            </div>
            <div className="metric-divider"></div>
            <div className="metric">
              <span className="metric-value">50ms</span>
              <span className="metric-label">Latency</span>
            </div>
            <div className="metric-divider"></div>
            <div className="metric">
              <span className="metric-value">99.7%</span>
              <span className="metric-label">Accuracy</span>
            </div>
          </div> */}
        </div>

        <div className="hero-visual">
          <div className="data-flow-container">
            <div className="flow-grid">
              {[...Array(20)].map((_, i) => (
                <div
                  key={i}
                  className={`flow-node ${activeNodes.has(i) ? 'active' : ''}`}
                >
                  <div className="node-core"></div>
                  {activeNodes.has(i) && (
                    <>
                      <div className="node-pulse"></div>
                      {/* <div className="node-connection"></div> */}
                    </>
                  )}
                </div>
              ))}
            </div>
            {/* <div className="flow-lines">
              <svg width="100%" height="100%" viewBox="0 0 400 400" preserveAspectRatio="none">
                <path
                  d="M 50 50 Q 200 100 350 50 T 350 350"
                  stroke="url(#gradient1)"
                  strokeWidth="2"
                  fill="none"
                  opacity="0.3"
                />
                <path
                  d="M 50 350 Q 200 300 350 350 T 50 50"
                  stroke="url(#gradient2)"
                  strokeWidth="2"
                  fill="none"
                  opacity="0.3"
                />
                <defs>
                  <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#4a69ff" />
                    <stop offset="100%" stopColor="#00d4ff" />
                  </linearGradient>
                  <linearGradient id="gradient2" x1="100%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#00d4ff" />
                    <stop offset="100%" stopColor="#4a69ff" />
                  </linearGradient>
                </defs>
              </svg>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
